import { Delete, Edit, Visibility } from "@mui/icons-material";

import styles from "./listing-card-layout.module.css";
import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { MdOutlineSettings } from "react-icons/md";
import { useMyListingsStore } from "../useMyListingsStore";
import { makeLocalizedHrefNoLocale } from "@/lib/localizedRoutes/routeHelpers";
import { myListingsSubRoutes } from "@/lib/localizedRoutes/localizedRoutes";

export default function ListingCardLayout({
  children,
  listing_id,
  locale,
  onPreviewTap,
  openModal,
}: {
  children: React.ReactNode;
  listing_id: string;
  locale: string;
  onPreviewTap: () => void;
  openModal: () => void;
}) {
  const t = useTranslations("MyListingsCard");
  const subRoute = myListingsSubRoutes.edit[locale];
  const { openDeleteModal } = useMyListingsStore();
  return (
    <div className={styles.cardWrapper}>
      {children}
      <div className={styles.actions}>
        <Link
          href={makeLocalizedHrefNoLocale(locale, "my-listings", [
            subRoute,
            `${listing_id}`,
          ])}
          className={styles.link}
        >
          <Edit />
          <span className={styles.text}>{t("edit")}</span>
        </Link>
        <div className={styles.actionsSeparator}></div>
        <button
          onClick={async (e) => {
            e.preventDefault();
            openDeleteModal(listing_id);
            // await deleteListing(listing_id, locale, idToken);
          }}
        >
          <Delete />
          <span className={styles.text}>{t("delete")}</span>
        </button>
        <div className={styles.actionsSeparator}></div>
        <button
          onClick={(e) => {
            e.preventDefault();
            onPreviewTap();
          }}
        >
          <Visibility />
          <span className={styles.text}>{t("preview")}</span>
        </button>
        <div className={styles.actionsSeparator}></div>
        <button
          onClick={async (e) => {
            e.preventDefault();
            openModal();
            // await activateListing(listing_id, idToken);
          }}
        >
          <MdOutlineSettings />
          <span className={styles.text}>{t("settings")}</span>
        </button>
      </div>
    </div>
  );
}

export function ListingCardLayoutLoading({
  children,
}: {
  children: React.ReactNode;
}) {
  const t = useTranslations("MyListingsCard");
  return (
    <div className={`${styles.cardWrapper} ${styles.listingCardLoading}`}>
      <div className={styles.childrenWrapper}>{children}</div>
      <div className={styles.actions}>
        <button onClick={(e) => e.preventDefault()}>
          <Edit />
          <span className={styles.text}>{t("edit")}</span>
        </button>
        <div className={styles.actionsSeparator}></div>
        <button onClick={(e) => e.preventDefault()}>
          <Delete />
          <span className={styles.text}>{t("delete")}</span>
        </button>
        <div className={styles.actionsSeparator}></div>
        <button onClick={(e) => e.preventDefault()}>
          <Visibility />
          <span className={styles.text}>{t("preview")}</span>
        </button>
        <div className={styles.actionsSeparator}></div>
        <button onClick={(e) => e.preventDefault()}>
          <MdOutlineSettings />
          <span className={styles.text}>{t("settings")}</span>
        </button>
      </div>
    </div>
  );
}
